
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import { IPagination } from '@/types';

import DialogImgLarge from '@/components/ImgLarge/index.vue';
import DialogDetail from '@/components/OrderDetail/index.vue';

import { chargeOffList, batchChargeOff } from '@/api/stock';
import { getOrderDetail, getOrderServiceProgressList } from '@/api/orderService';

@Component({
  name: 'StockVerification',
  components: {
    DialogImgLarge,
    DialogDetail
  }
})
export default class extends Vue {
  private formSearch = {
    parts_name: '',
    parts_model_name: '',
    serial_number: '',
    specification: '',
    order_times: '',
    order_num: ''
  }
  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };
  private dataTable = []
  private loading = false
  private dialogDetailVisible = false
  private showComplaintBtn = false
  private detail:any = {}
  private selectedMultiple = []

  created() {
    this.getList();
  }

  private getList() {
    this.loading = true;
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.user_name = UserModule.getUserName;
    params.company_id = UserModule.getCompanyId;
    params.company_name = UserModule.getCompanyName;
    params.is_charge_off = '0';
    params.parts_name = this.formSearch.parts_name;
    params.parts_model_name = this.formSearch.parts_model_name;
    params.serial_number = this.formSearch.serial_number;
    params.specification = this.formSearch.specification;
    if (this.formSearch.order_times) {
      let data = new Date(this.formSearch.order_times);
      params.order_times = data.getTime() / 1000;
    }
    params.order_num = this.formSearch.order_num;
    params.page = this.pagination.currentPage;
    params.size = this.pagination.pageSize;
    chargeOffList(params)
      .then((res) => {
        this.loading = false;
        // alert(JSON.stringify(res.data));
        if (res.data) {
          this.pagination.total = parseInt(res.data.count);
          this.dataTable = res.data.list;
        } else {
          // //当页面不是第一页时 清空所有分页数据
          // if(  1 == this.pagination.currentPage ){
          //   this.pagination.currentPage = 1;
          //   this.pagination.total = 0;
          //   this.dataTable = [];
          // }else{
            //如果是其它页保持页数 清空数据
            this.pagination.total = parseInt(res.data.count);
            this.dataTable = [];
          // }
        }
      })
      .catch((error) => {
        this.loading = false;
        this.dataTable = [];
        let msg = error.msg;
      });
  }

  // 页面属性更新
  private handlePageSizeChange(val: any) {
    this.pagination.pageSize = val;
    this.getList();
  }
  private handleCurrentChange(val: any) {
    this.pagination.currentPage = val;
    this.getList();
  }

  private search() {
    this.getList();
  }

  private searchClean() {
    this.formSearch = {
      parts_name: '',
      parts_model_name: '',
      serial_number: '',
      specification: '',
      order_times: '',
      order_num: ''
    };
    this.getList();
  }

  private handleSelect(rows: any, row: any) {
    this.selectedMultiple = rows;
  }
  private handleSelectAll(rows: any) {
    this.selectedMultiple = rows;
  }
  private orderProgressData = {};
  private detailHandle(val:any) {
    let params = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      order_id: val.id
    };
    getOrderDetail(params)
      .then((res: any) => {
        const data = res.data;
        if (data !== null) {
          this.dialogDetailVisible = true;
          this.detail = data;
          let p: any = {};
          p.user_id = UserModule.getUserId;
          p.company_id = UserModule.getCompanyId;
          p.order_id = val.id;
          p.user_name = UserModule.getUserName;
          p.order_service_id = this.detail.order_service.id;
          getOrderServiceProgressList(p)
            .then((res) => {
              const data = res.data;
              if (data !== null) {
                this.orderProgressData = data;
              } else {
                this.orderProgressData = {};
              }
              if (
                (this.orderProgressData as any).list &&
                (this.orderProgressData as any).list.length > 0
              ) {
                (this.orderProgressData as any).list[0].color =
                  "rgba(185, 235, 247,1)";
              }
              if (
                (this.orderProgressData as any).added_progress &&
                (this.orderProgressData as any).added_progress.length > 0
              ) {
                (this.orderProgressData as any).added_progress[0].color =
                  "rgba(185, 235, 247,1)";
              }
            })
            .catch((err) => {
              let msg = err.msg;
              this.orderProgressData = {};
            });
        }
      })
      .catch((err: any) => {
        let msg = err.msg;
      });
    
  }
  private closeDetailHandle(val: any) {
    this.dialogDetailVisible = val;
  }
  // 批量核销
  private verifyGroupHandle() {
    if (this.selectedMultiple && this.selectedMultiple.length > 0) {
      let _ = this;
      let arr:any = [];
      this.selectedMultiple.map(function(item:any) {
        if (item.parts && item.parts.length > 0) {
          item.parts.map(function(itemc:any) {
            let t = _.getData(itemc, item);
            arr.push(t);
          });
        }
      });
      this.verify(arr);
    } else {
      this.showErrorMsg('请先选择核销单');
    }
  }

  // 全部核销
  private verifyAll(val:any) {
    let _ = this;
    let arr:any = [];
    if (val.parts && val.parts.length > 0) {
      val.parts.map(function(item:any) {
        let t = _.getData(item, val);
        arr.push(t);
      });
    }
    this.verify(arr);
  }
  // 单独核销一个
  private verifyCurrent(val:any, val2:any) {
    let arr:any = [];
    let t = this.getData(val, val2);
    arr.push(t);
    this.verify(arr);
  }

  private verify(arr:any) {

    this.$confirm("请确认是否核销！", "确认核销?", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
    .then(() => {
        let params: any = {};
        params.user_id = UserModule.getUserId;
        params.user_name = UserModule.getUserName;
        params.company_id = UserModule.getCompanyId;
        params.company_name = UserModule.getCompanyName;
        params.batch_data = JSON.stringify(arr);
        batchChargeOff(params)
          .then((res) => {
            this.showSuccessMsg('核销成功');
            this.getList();
          })
          .catch((error) => {
            let msg = error.msg;
            this.showErrorMsg(msg);
          });        
      })
    .catch(() => {});

  }


  // 组织单个核销的数据
  private getData(val:any, val2:any) {
    let temp:any = {};
    temp.stock_id = val.stock_id;
    temp.stock_name = val.parts_name;
    temp.model_id = val.stock_model_id;
    temp.model_name = val.parts_model_name;
    temp.serial_number = val.serial_number;
    temp.specification = val.specification;
    temp.image_save_path = val.image_save_path;
    temp.num = val.parts_amount;
    temp.inout_user_id = val.p_user_id;
    temp.inout_user_name = val.p_user_name;
    temp.order_parts_id = val.order_parts_id;
    temp.order_service_id =  val.order_service_id;
    temp.order_num = val2.order_num;
    if (parseInt(val2.customer_company_id) === 0) {
      temp.customer_user_id = val2.customer_user_id;
      temp.customer_user_name = val2.customer_user_name;
    } else {
      temp.customer_company_id = val2.customer_company_id;
      temp.customer_company_name = val2.customer_company_name;
    }
    return temp;
  }

  private large(val: [], index: number) {
    let enlargedData = {
      isShow: true,
      imgList: val,
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
